import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountryCityService {

  constructor(private http: HttpClient) { }

  // =========================
  // Helper: Build Params
  // =========================

  private buildParams(filters: any = {}): HttpParams {
    let params = new HttpParams();

    Object.keys(filters).forEach(key => {
      if (
        filters[key] !== null &&
        filters[key] !== undefined &&
        filters[key] !== ''
      ) {
        params = params.set(key, filters[key]);
      }
    });

    return params;
  }

  // =========================
  // Countries
  // =========================

  getCountries(filters: any = {}): Observable<any> {
    const params = this.buildParams(filters);

    return this.http.get(`${environment.Server_URL}/countries`, { params });
  }

  getCountry(id: any): Observable<any> {
    return this.http.get(`${environment.Server_URL}/countries/${id}`);
  }

  addCountry(data: any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/countries`, data);
  }

  updateCountry(id: any, data: any): Observable<any> {
    return this.http.put(`${environment.Server_URL}/countries/${id}`, data);
  }

  deleteCountry(id: any): Observable<any> {
    return this.http.delete(`${environment.Server_URL}/countries/${id}`);
  }

  // =========================
  // Cities
  // =========================

  getCities(filters: any = {}): Observable<any> {
    const params = this.buildParams(filters);

    return this.http.get(`${environment.Server_URL}/cities`, { params });
  }

  getCity(id: any): Observable<any> {
    return this.http.get(`${environment.Server_URL}/cities/${id}`);
  }

  addCity(data: any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/cities`, data);
  }

  updateCity(id: any, data: any): Observable<any> {
    return this.http.put(`${environment.Server_URL}/cities/${id}`, data);
  }

  deleteCity(id: any): Observable<any> {
    return this.http.delete(`${environment.Server_URL}/cities/${id}`);
  }

  // =========================
  // Cities By Country
  // =========================

  getCitiesByCountry(countryId: any): Observable<any> {
    return this.http.get(`${environment.Server_URL}/countries/${countryId}/cities`);
  }
}